import React, { Component, Fragment } from 'react'
import {
  withStyles,
  CircularProgress,
  Typography,
  Fade,
  Menu,
  MenuItem,
  Snackbar,
  SnackbarContent,
  InputBase,
  Select,
  IconButton,
  Chip,
  Checkbox,
} from '@material-ui/core'
import Cookies from 'js-cookie'
import TelegramIcon from '@material-ui/icons/Telegram'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import WarningIcon from '@material-ui/icons/Warning'
import Stats from '../roi/Stats'
import RoiCharts from '../roi/RoiCharts'
import TriggerTypesTable from './TriggerTypesTable'
import TrigLocationsTable from './TrigLocationsTable'
import DatePicker from '../calendar/DatePicker'
import DayPicker from '../calendar/DayPicker'
import roiMainStandIn from '../../assets/mainStandIns/roiMainStandIn.png'
import RoiExcel from '../roi/RoiExcel'
import RoiTable from '../roi/RoiTable'

import moment from 'moment'

const base_url = "https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/"

const styles = theme => ({
  root: {
    margin: '1em'
  },
  loader: {
    // marginTop: '25%',
    // marginLeft: '50%'
    marginTop: '50vh',
    marginLeft: '50vw'
  },
  chart: {
    padding: theme.spacing(5)
  },
  pageTitle:  {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '20px',
    fontWeight: 'light',
    color: 'rgba(115, 115, 115, 0.9)'
  },
  pageTitleDark:  {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '20px',
    fontWeight: 'light',
    color: 'rgba(255, 255, 255, 0.9)'
  },
  pageIcon: {
    fontSize: '17px',
    marginRight: '2px'
  },
  pageIconDark: {
    fontSize: '15px',
    color: 'rgba(255, 255, 255, 0.9)',
    marginTop: '5px',
    marginRight: '2px',
  },
  mailingType: {
    color: '#25aae1',
    '&:hover': {
      cursor: 'pointer',
    }
  },
  mailingTypeDark: {
    color: '#4ab8bb',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  unavailable: {
    position: 'absolute',
    textAlign: 'center',
    [theme.breakpoints.up('xl')]: {
      top: '35%',
      left: '12.5%',
    },
    [theme.breakpoints.down('lg')]: {
      top: '35%'
    }
  },
  warning: {
    border: '1px solid #de9f10',
    borderRadius: 10,
    textAlign: 'center'
  },
  hidden: {
    display: 'none'
  },
  chip: {
    margin: 1,
    height: '20px',
    padding: '0px 2px 0px 2px',
    border: '1px solid #636768',
    fontSize: '10px',
    backgroundColor: 'rgba(231, 231, 231, 0.6)',
  },
  chips: {
    display: 'flex',
  },
  datePicker: {
    width: 400
  },
  filter: {
    textAlign: 'right',
  },
  holdoutMessage: {
    marginRight: theme.spacing(1.5),
    margin: '1em',
  }
})

const StyledInput = withStyles((theme) => ({
  input: {
    borderRadius: 8,
    overflowX: 'auto',
    position: 'relative',
    padding: '2px 5px 2.5px 5px',
    border: '1px solid #fff',
    color: "#fff",
    fontSize: 7,
    '&:focus': {
      border: '1px solid',
      borderRadius: 8,
      borderColor: '#25aae1',
      backgroundColor: 'transparent',
    }
  }
}))(InputBase)

class Triggers extends Component {
  _isMounted = false

  constructor() {
    super()
    this.state = {
      triggerData: [],
      custPros: [],
      trigType: [],
      weeklyInc: [],
      triggerMarketData: [],
      corpID: JSON.parse(localStorage.getItem('currentUser'))[0].corporateID,
      startDate: moment().diff(moment().startOf('year'), 'months') > 3 ? JSON.parse(localStorage.getItem('currentUser'))[0].db_owner === 'KHOOK' ? moment(JSON.parse(localStorage.getItem('currentUser'))[0].max_date_trig).startOf('year') : moment().startOf('year') : moment().startOf('year').subtract(1, 'years'),
      initialStartDate: moment().diff(moment().startOf('year'), 'months') > 3 ? JSON.parse(localStorage.getItem('currentUser'))[0].db_owner === 'KHOOK' ? moment(JSON.parse(localStorage.getItem('currentUser'))[0].max_date_trig).startOf('year') : moment().startOf('year') : moment().startOf('year').subtract(1, 'years'),
      endDate: JSON.parse(localStorage.getItem('currentUser'))[0].max_date_trig ? moment(JSON.parse(localStorage.getItem('currentUser'))[0].max_date_trig) : moment(),
      initialEndDate: JSON.parse(localStorage.getItem('currentUser'))[0].max_date_trig ? moment(JSON.parse(localStorage.getItem('currentUser'))[0].max_date_trig) : moment(),
      isLoading: true,
      marketLoading: false,
      mailingOpen: false,
      mailingType: 'completed',
      anchor: null,
      complete: 1,
      hasData: false,
      snackbar: false,
      errorMessage: '',
      dataOverall: [],
      dataWeekly: [],
      dataCustPros: [],
      dataTrigType: [],
      selectedMarkets: ['ALL'],
      selectedType: 'market',
      maxYearmo: JSON.parse(localStorage.getItem('currentUser'))[0].max_date_trig ? moment(JSON.parse(localStorage.getItem('currentUser'))[0].max_date_trig) : moment(),
      minYearmo: moment().diff(moment().startOf('year'), 'months') > 3 ? JSON.parse(localStorage.getItem('currentUser'))[0].db_owner === 'KHOOK' ? moment(JSON.parse(localStorage.getItem('currentUser'))[0].max_date_trig).startOf('year') : moment().startOf('year') : moment().startOf('year').subtract(1, 'years'),
      days: 0,
      restoreHidden: true,
      checked: [],
      checkList: [],
    }

    this.handleDateClear = this.handleDateClear.bind(this)
  }

  handleDateRange = (value, valName) => {
    const myHeaders = {'token': Cookies.get('token')}
    const trigData = []
    let complete = this.state.mailingType === 'completed' ? 1 : 0

    if(valName === 'startDate') {
      if(this.state.selectedType === 'market') {
        Promise.all([
          fetch(`${base_url}/triggerROI?startDate=${value.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
          fetch(`${base_url}/triggerROI/custPros?startDate=${value.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
          fetch(`${base_url}/triggerRoi/trigType?startDate=${value.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
          fetch(`${base_url}/triggerROI/weekly?startDate=${value.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders,}),
          fetch(`${base_url}/triggerROI/dashboard/${this.state.selectedType}?startDate=${value.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders,}),
          fetch(`${base_url}/triggerROI/dashboard?startDate=${value.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders,})
        ])
        .then(([response1, response2, response3, response4, response5, response6]) => Promise.all([response1.json(), response2.json(), response3.json(), response4.json(), response5.json(), response6.json()]))
        .then(([data1, data2, data3, data4, data5, data6]) => {

          if(data1) {
            let trigObj = {}
            trigObj['Data_CustPros'] = data2
            trigObj['Data_Location'] = data6[0].Data_Location
            trigObj['Data_TrigType'] = data3
            trigObj['Data_Weekly'] = data4
            trigObj['Data_Overall'] = data1[0].Data
            trigObj['Label'] = 'ALL'
            trigObj['Key'] = data5.length + 1
            trigData.push(trigObj)

            this.setState({
              isLoading: false,
              hasData: true,
              triggerData: trigData.concat(data5),
              selectedTriggerData: trigData.concat(data5).filter(item => this.state.selectedMarkets.includes(item.Label)),
              triggerMarketData: data5,
              restoreHidden: false,
              days: this.state.endDate.diff(value, 'days'),
              [valName]: value,

            })

            this.handleMarketChange(this.state.selectedMarkets)
          } else {
            this.setState({
              isLoading: false,
              snackbar: true,
              errorMessage: 'Trigger ROI is not available for the selected dates. Please broaden the date range',
              days: this.state.endDate.diff(value, 'days'),
              restoreHidden: false,
              startDate: value
            })
          }
        })
      } else {
        Promise.all([
          fetch(`${base_url}/triggerROI?startDate=${value.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
          fetch(`${base_url}/triggerROI/custPros?startDate=${value.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
          fetch(`${base_url}/triggerRoi/trigType?startDate=${value.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
          fetch(`${base_url}/triggerROI/weekly?startDate=${value.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders,}),
          fetch(`${base_url}/triggerROI/dashboard/${this.state.selectedType}?startDate=${value.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${1}`, {headers: myHeaders,})
        ])
        .then(([response1, response2, response3, response4, response5]) => Promise.all([response1.json(), response2.json(), response3.json(), response4.json(), response5.json()]))
        .then(([data1, data2, data3, data4, data5]) => {

          if(data1) {
            let trigObj = {}
            trigObj['Data_CustPros'] = data2
            trigObj['Data_TrigType'] = data3
            trigObj['Data_Weekly'] = data4
            trigObj['Data_Overall'] = data1[0].Data
            trigObj['Label'] = 'ALL'
            trigObj['Key'] = data5.length + 1
            trigData.push(trigObj)

            console.log('hey')
            console.log(data5)

            this.setState({
              isLoading: false,
              hasData: true,
              triggerData: trigData.concat(data5),
              selectedTriggerData: trigData.concat(data5).filter(item => this.state.selectedMarkets.includes(item.Label)),
              triggerMarketData: data5,
              restoreHidden: false,
              days: this.state.endDate.diff(value, 'days'),
              [valName]: value,

            })

            this.handleMarketChange(this.state.selectedMarkets)
          } else {
            this.setState({
              isLoading: false,
              snackbar: true,
              errorMessage: 'Trigger ROI is not available for the selected dates. Please broaden the date range',
              days: this.state.endDate.diff(value, 'days'),
              restoreHidden: false,
              startDate: value,
              triggerData: [],
              selectedTriggerData: [],
              triggerMarketData: [],
            })
          }
        })
      }
    } else {
      if(this.state.selectedType === 'market') {
        Promise.all([
          fetch(`${base_url}/triggerROI?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${value.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
          fetch(`${base_url}/triggerROI/custPros?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${value.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
          fetch(`${base_url}/triggerRoi/trigType?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${value.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
          fetch(`${base_url}/triggerROI/weekly?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${value.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders,}),
          fetch(`${base_url}/triggerROI/dashboard/${this.state.selectedType}?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${value.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders,}),
          fetch(`${base_url}/triggerROI/dashboard?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${value.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders,})
        ])
        .then(([response1, response2, response3, response4, response5, response6]) => Promise.all([response1.json(), response2.json(), response3.json(), response4.json(), response5.json(), response6.json()]))
        .then(([data1, data2, data3, data4, data5, data6]) => {

          if(data1) {
            let trigObj = {}
            trigObj['Data_CustPros'] = data2
            trigObj['Data_Location'] = data6[0].Data_Location
            trigObj['Data_TrigType'] = data3
            trigObj['Data_Weekly'] = data4
            trigObj['Data_Overall'] = data1[0].Data
            trigObj['Label'] = 'ALL'
            trigObj['Key'] = data5.length + 1
            trigData.push(trigObj)

            console.log('hello')
            console.log(data5)

            this.setState({
              isLoading: false,
              hasData: true,
              triggerData: trigData.concat(data5),
              selectedTriggerData: trigData.concat(data5).filter(item => this.state.selectedMarkets.includes(item.Label)),
              triggerMarketData: data5,
              restoreHidden: false,
              days: value.diff(this.state.startDate, 'days'),
              [valName]: value,

            })

            this.handleMarketChange(this.state.selectedMarkets)
          } else {
            this.setState({
              isLoading: false,
              snackbar: true,
              errorMessage: 'Trigger ROI is not available for the selected dates. Please broaden the date range',
              days: value.diff(this.state.startDate, 'days'),
              restoreHidden: false,
              triggerData: [],
              selectedTriggerData: [],
              triggerMarketData: [],
              endDate: value,
            })
          }
        })
      } else {
        Promise.all([
          fetch(`${base_url}/triggerROI?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${value.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
          fetch(`${base_url}/triggerROI/custPros?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${value.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
          fetch(`${base_url}/triggerRoi/trigType?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${value.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
          fetch(`${base_url}/triggerROI/weekly?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${value.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders,}),
          fetch(`${base_url}/triggerROI/dashboard/${this.state.selectedType}?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${value.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders,})
        ])
        .then(([response1, response2, response3, response4, response5]) => Promise.all([response1.json(), response2.json(), response3.json(), response4.json(), response5.json()]))
        .then(([data1, data2, data3, data4, data5]) => {

          if(data1) {
            let trigObj = {}
            trigObj['Data_CustPros'] = data2
            trigObj['Data_TrigType'] = data3
            trigObj['Data_Weekly'] = data4
            trigObj['Data_Overall'] = data1[0].Data
            trigObj['Label'] = 'ALL'
            trigObj['Key'] = data5.length + 1
            trigData.push(trigObj)

            this.setState({
              isLoading: false,
              hasData: true,
              triggerData: trigData.concat(data5),
              selectedTriggerData: trigData.concat(data5).filter(item => this.state.selectedMarkets.includes(item.Label)),
              triggerMarketData: data5,
              restoreHidden: false,
              days: value.diff(this.state.startDate, 'days'),
              [valName]: value,

            })

            this.handleMarketChange(this.state.selectedMarkets)
          } else {
            this.setState({
              isLoading: false,
              snackbar: true,
              errorMessage: 'Trigger ROI is not available for the selected dates. Please broaden the date range',
              days: value.diff(this.state.startDate, 'days'),
              restoreHidden: false,
              triggerData: [],
              selectedTriggerData: [],
              triggerMarketData: [],
              endDate: value,
            })
          }
        })
      }
    }
  }

  handleSliderDateChange = (values) => {
    const myHeaders = {'token': Cookies.get('token')}
    const trigData = []
    let complete = this.state.mailingType === 'completed' ? 1 : 0

    const startDate = values[0]
    const endDate = values[1]
    if(this.state.selectedType === 'market') {
      Promise.all([
        fetch(`${base_url}/triggerROI?startDate=${startDate}&endDate=${endDate}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerROI/custPros?startDate=${startDate}&endDate=${endDate}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerRoi/trigType?startDate=${startDate}&endDate=${endDate}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerROI/weekly?startDate=${startDate}&endDate=${endDate}&complete=${complete}`, {headers: myHeaders,}),
        fetch(`${base_url}/triggerROI/dashboard/${this.state.selectedType}?startDate=${startDate}&endDate=${endDate}&complete=${complete}`, {headers: myHeaders,}),
        fetch(`${base_url}/triggerROI/dashboard?startDate=${startDate}&endDate=${endDate}&complete=${complete}`, {headers: myHeaders,})
      ])
      .then(([response1, response2, response3, response4, response5, response6]) => Promise.all([response1.json(), response2.json(), response3.json(), response4.json(), response5.json(), response6.json()]))
      .then(([data1, data2, data3, data4, data5, data6]) => {
        let trigObj = {}

        if(this._isMounted && data1) {
          trigObj['Data_CustPros'] = data2
          trigObj['Data_Location'] = data6[0].Data_Location
          trigObj['Data_TrigType'] = data3
          trigObj['Data_Weekly'] = data4
          trigObj['Data_Overall'] = data1[0].Data
          trigObj['Label'] = 'ALL'
          trigObj['Key'] = data5.length + 1
          trigData.push(trigObj)

          this.setState({
            isLoading: false,
            hasData: true,
            triggerData: trigData.concat(data5),
            selectedTriggerData: trigData.concat(data5).filter(item => this.state.selectedMarkets.includes(item.Label)),
            triggerMarketData: data5,
            startDate: moment(values[0]),
            endDate: moment(values[1]),
            restoreHidden: false,
          })

          this.handleMarketChange(this.state.selectedMarkets)
        } else {
          this.setState({
            isLoading: false,
            snackbar: true,
            errorMessage: 'Trigger ROI is not available for the selected dates. Please broaden the date range',
            restoreHidden: false,
            triggerData: [],
            selectedTriggerData: [],
            triggerMarketData: [],
            startDate: moment(values[0]),
            endDate: moment(values[1]),
          })

        }
      })
    } else {
      Promise.all([
        fetch(`${base_url}/triggerROI?startDate=${startDate}&endDate=${endDate}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerROI/custPros?startDate=${startDate}&endDate=${endDate}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerRoi/trigType?startDate=${startDate}&endDate=${endDate}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerROI/weekly?startDate=${startDate}&endDate=${endDate}&complete=${complete}`, {headers: myHeaders,}),
        fetch(`${base_url}/triggerROI/dashboard/${this.state.selectedType}?startDate=${startDate}&endDate=${endDate}&complete=${complete}`, {headers: myHeaders,}),
      ])
      .then(([response1, response2, response3, response4, response5]) => Promise.all([response1.json(), response2.json(), response3.json(), response4.json(), response5.json()]))
      .then(([data1, data2, data3, data4, data5]) => {

        if(this._isMounted && data1) {
          let trigObj = {}
          trigObj['Data_CustPros'] = data2
          trigObj['Data_TrigType'] = data3
          trigObj['Data_Weekly'] = data4
          trigObj['Data_Overall'] = data1[0].Data
          trigObj['Label'] = 'ALL'
          trigObj['Key'] = data5.length + 1
          trigData.push(trigObj)

          this.setState({
            isLoading: false,
            hasData: true,
            triggerData: trigData.concat(data5),
            selectedTriggerData: trigData.concat(data5).filter(item => this.state.selectedMarkets.includes(item.Label)),
            triggerMarketData: data5,
            startDate: moment(values[0]),
            endDate: moment(values[1]),
            restoreHidden: false,
          })

          this.handleMarketChange(this.state.selectedMarkets)
        } else {
          this.setState({
            isLoading: false,
            snackbar: true,
            errorMessage: 'Trigger ROI is not available for the selected dates. Please broaden the date range',
            restoreHidden: false,
            triggerData: [],
            selectedTriggerData: [],
            triggerMarketData: [],
            startDate: moment(values[0]),
            endDate: moment(values[1]),
          })
        }
      })
    }
  }

  handleDateClear() {
    const myHeaders = {'token': Cookies.get('token')}
    let trigData = []
    let complete = this.state.mailingType === 'completed' ? 1 : 0

    if(this.state.selectedType === 'market') {
      Promise.all([
        fetch(`${base_url}/triggerROI?startDate=${this.state.initialStartDate.format('YYYY-MM-DD')}&endDate=${this.state.initialEndDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerROI/custPros?startDate=${this.state.initialStartDate.format('YYYY-MM-DD')}&endDate=${this.state.initialEndDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerRoi/trigType?startDate=${this.state.initialStartDate.format('YYYY-MM-DD')}&endDate=${this.state.initialEndDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerROI/weekly?startDate=${this.state.initialStartDate.format('YYYY-MM-DD')}&endDate=${this.state.initialEndDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerROI/dashboard/${this.state.selectedType}?startDate=${this.state.initialStartDate.format('YYYY-MM-DD')}&endDate=${this.state.initialEndDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerROI/dashboard?startDate=${this.state.initialStartDate.format('YYYY-MM-DD')}&endDate=${this.state.initialEndDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
      ])
      .then(([resp1, resp2, resp3, resp4, resp5, resp6]) => Promise.all([resp1.json(), resp2.json(), resp3.json(), resp4.json(), resp5.json(), resp6.json()]))
      .then(([data1, data2, data3, data4, data5, data6]) => {
        let trigObj = {}
        trigObj['Data_CustPros'] = data2
        trigObj['Data_Location'] = data6[0].Data_Location
        trigObj['Data_TrigType'] = data3
        trigObj['Data_Weekly'] = data4
        trigObj['Data_Overall'] = data1[0].Data
        trigObj['Label'] = 'ALL'
        trigObj['Key'] = data5.length + 1
        trigData.push(trigObj)

        if(data1) {
          this.setState({
            isLoading: false,
            hasData: true,
            triggerData: trigData.concat(data5),
            selectedTriggerData: trigData.concat(data5).filter(item => this.state.selectedMarkets.includes(item.Label)),
            triggerMarketData: data5,
            restoreHidden: true,
            startDate: this.state.initialStartDate,
            endDate: this.state.initialEndDate,
            minYearmo: this.state.initialStartDate,
            maxYearmo: this.state.initialEndDate,
            days: this.state.initialEndDate.diff(this.state.initialStartDate, 'days'),
          })

          this.handleMarketChange(this.state.selectedMarkets)
        } else {
          this.setState({
            isLoading: false,
            hasData: false,
          })
        }
      })
      .catch(error => {
        console.log(error)
      })
    } else {
      Promise.all([
        fetch(`${base_url}/triggerROI?startDate=${this.state.initialStartDate.format('YYYY-MM-DD')}&endDate=${this.state.initialEndDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerROI/custPros?startDate=${this.state.initialStartDate.format('YYYY-MM-DD')}&endDate=${this.state.initialEndDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerRoi/trigType?startDate=${this.state.initialStartDate.format('YYYY-MM-DD')}&endDate=${this.state.initialEndDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerROI/weekly?startDate=${this.state.initialStartDate.format('YYYY-MM-DD')}&endDate=${this.state.initialEndDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerROI/dashboard/${this.state.selectedType}?startDate=${this.state.initialStartDate.format('YYYY-MM-DD')}&endDate=${this.state.initialEndDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
      ])
      .then(([resp1, resp2, resp3, resp4, resp5]) => Promise.all([resp1.json(), resp2.json(), resp3.json(), resp4.json(), resp5.json()]))
      .then(([data1, data2, data3, data4, data5]) => {
        let trigObj = {}
        trigObj['Data_CustPros'] = data2
        trigObj['Data_TrigType'] = data3
        trigObj['Data_Weekly'] = data4
        trigObj['Data_Overall'] = data1[0].Data
        trigObj['Label'] = 'ALL'
        trigObj['Key'] = data5.length + 1
        trigData.push(trigObj)

        if(data1) {
          this.setState({
            isLoading: false,
            hasData: true,
            triggerData: trigData.concat(data5),
            selectedTriggerData: trigData.concat(data5).filter(item => this.state.selectedMarkets.includes(item.Label)),
            triggerMarketData: data5,
            restoreHidden: true,
            startDate: this.state.initialStartDate,
            endDate: this.state.initialEndDate,
            minYearmo: this.state.initialStartDate,
            maxYearmo: this.state.initialEndDate,
            days: this.state.initialEndDate.diff(this.state.initialStartDate, 'days'),
          })

          this.handleMarketChange(this.state.selectedMarkets)
        } else {
          this.setState({
            isLoading: false,
            hasData: false,
          })
        }
      })
      .catch(error => {
        console.log(error)
      })
    }
  }

  componentDidMount() {
    this._isMounted = true
    const myHeaders = {'token': Cookies.get('token')}
    let trigData = []

    Promise.all([
      fetch(`${base_url}/triggerROI?startDate=${this.state.initialStartDate.format('YYYY-MM-DD')}&endDate=${this.state.initialEndDate.format('YYYY-MM-DD')}`, {headers: myHeaders}),
      fetch(`${base_url}/triggerROI/custPros?startDate=${this.state.initialStartDate.format('YYYY-MM-DD')}&endDate=${this.state.initialEndDate.format('YYYY-MM-DD')}`, {headers: myHeaders}),
      fetch(`${base_url}/triggerRoi/trigType?startDate=${this.state.initialStartDate.format('YYYY-MM-DD')}&endDate=${this.state.initialEndDate.format('YYYY-MM-DD')}`, {headers: myHeaders}),
      fetch(`${base_url}/triggerROI/weekly?startDate=${this.state.initialStartDate.format('YYYY-MM-DD')}&endDate=${this.state.initialEndDate.format('YYYY-MM-DD')}`, {headers: myHeaders,}),
      fetch(`${base_url}/triggerROI/dashboard/market?startDate=${this.state.initialStartDate.format('YYYY-MM-DD')}&endDate=${this.state.initialEndDate.format('YYYY-MM-DD')}`, {headers: myHeaders,}),
      fetch(`${base_url}/triggerROI/dashboard?startDate=${this.state.initialStartDate.format('YYYY-MM-DD')}&endDate=${this.state.initialEndDate.format('YYYY-MM-DD')}`, {headers: myHeaders,}),
    ])
    .then(([resp1, resp2, resp3, resp4, resp5, resp6]) => Promise.all([resp1.json(), resp2.json(), resp3.json(), resp4.json(), resp5.json(), resp6.json()]))
    .then(([data1, data2, data3, data4, data5, data6]) => {
      if(this._isMounted && data1.length > 0 && JSON.parse(localStorage.getItem('currentUser'))[0].compIDs !== '260') {

        let trigObj = {}
        trigObj['Data_CustPros'] = data2
        trigObj['Data_Location'] = data6[0].Data_Location
        trigObj['Data_TrigType'] = data3
        trigObj['Data_Weekly'] = data4
        trigObj['Data_Overall'] = data1[0].Data
        trigObj['Label'] = 'ALL'
        trigObj['Key'] = data5.length + 1
        trigData.push(trigObj)

        this.setState({
          isLoading: false,
          hasData: true,
          triggerData: trigData.concat(data5),
          selectedTriggerData: trigData.filter(item => item.Label === 'ALL'),
          triggerMarketData: data5,
          days: this.state.initialEndDate.diff(this.state.initialStartDate, 'days'),
          checked: trigData.concat(data5).map(item => item.Label),
          checkList: trigData.concat(data5).map(item => item.Label),
        })
      } else {
        this.setState({
          isLoading: false,
          hasData: false,
        })
      }
    })
    .catch(error => {
      console.log(error)
    })

    // if(JSON.parse(localStorage.getItem('currentUser'))[0].username.toUpperCase().includes('USER')) {
    // } else {
    //   fetch(`${base_url}/pageviews/add?display=triggers&screen_name=triggers`, {
    //     method: 'POST',
    //     headers: {
    //       'Access-Control-Allow-Origin': '*',
    //       'token': Cookies.get('token'),
    //     },
    //   })
    //   .then(response => {
    //     if(response.ok === true) {
    //       return response.json()
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
    // }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  handleSnackbarClose = (e, reason) => {
    if(reason === 'clickaway') {
      this.setState({
        snackbar: false,
      })
    }
    this.setState({
      snackbar: false
    })
  }

  handleSelectedType = value => {
    const myHeaders = {'token': Cookies.get('token')}
    let trigData = []
    let complete = this.state.mailingType === 'completed' ? 1 : 0

    this.setState({
      marketLoading: true,
    })

    if(value === 'market') {
      Promise.all([
        fetch(`${base_url}/triggerROI?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerROI/custPros?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerRoi/trigType?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerROI/weekly?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders,}),
        fetch(`${base_url}/triggerROI/dashboard/market?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders,}),
        fetch(`${base_url}/triggerROI/dashboard?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders,}),
      ])
      .then(([resp1, resp2, resp3, resp4, resp5, resp6]) => Promise.all([resp1.json(), resp2.json(), resp3.json(), resp4.json(), resp5.json(), resp6.json()]))
      .then(([data1, data2, data3, data4, data5, data6]) => {
        if(data1.length > 0) {
          let trigObj = {}
          trigObj['Data_CustPros'] = data2
          trigObj['Data_Location'] = data6[0].Data_Location
          trigObj['Data_TrigType'] = data3
          trigObj['Data_Weekly'] = data4
          trigObj['Data_Overall'] = data1[0].Data
          trigObj['Label'] = 'ALL'
          trigObj['Key'] = data5.length + 1
          trigData.push(trigObj)

          this.setState({
            marketLoading: false,
            hasData: true,
            triggerData: trigData.concat(data5),
            selectedTriggerData: trigData.filter(item => item.Label === 'ALL'),
            triggerMarketData: data5,
            selectedMarkets: ['ALL'],
            checked: trigData.concat(data5).map(item => item.Label),
            checkList: trigData.concat(data5).map(item => item.Label),
          })

          console.log(trigData.filter(item => item.Label === 'ALL'))
        } else {
          this.setState({
            isLoading: false,
            snackbar: true,
            errorMessage: 'Trigger ROI is not available for the selection(s) you have made. Please broaden your search and try again.',
            restoreHidden: false,
          })
        }
      })
      .catch(error => {
        console.log(error)
      })
    } else {
      Promise.all([
        fetch(`${base_url}/triggerROI?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerROI/custPros?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerRoi/trigType?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
        fetch(`${base_url}/triggerROI/weekly?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders,}),
        fetch(`${base_url}/triggerROI/dashboard/location?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders,}),
      ])
      .then(([resp1, resp2, resp3, resp4, resp5]) => Promise.all([resp1.json(), resp2.json(), resp3.json(), resp4.json(), resp5.json()]))
      .then(([data1, data2, data3, data4, data5]) => {
        if(data1.length > 0) {
          let trigObj = {}
          trigObj['Data_CustPros'] = data2
          trigObj['Data_TrigType'] = data3
          trigObj['Data_Weekly'] = data4
          trigObj['Data_Overall'] = data1[0].Data
          trigObj['Label'] = 'ALL'
          trigObj['Key'] = data5.length + 1
          trigData.push(trigObj)

          this.setState({
            marketLoading: false,
            hasData: true,
            triggerData: trigData.concat(data5),
            selectedTriggerData: trigData.filter(item => item.Label === 'ALL'),
            triggerMarketData: data5,
            selectedMarkets: ['ALL'],
            checked: trigData.concat(data5).map(item => item.Label),
            checkList: trigData.concat(data5).map(item => item.Label),
          })
        } else {
          this.setState({
            isLoading: false,
            snackbar: true,
            errorMessage: 'Trigger ROI is not available for the selection(s) you have made. Please broaden your search and try again.',
          })
        }
      })
      .catch(error => {
        console.log(error)
      })
    }


    this.setState({
      selectedType: value
    })
  }

  handleMarketChange = values => {
    let selectedTrigMarkets = []
    let newChecked = [...this.state.checked]
    let selectedData = []

    if(values.length > 0) {
      let selected = values.filter(item => item !== "ALL")[0]

      if(this.state.checked.indexOf(selected) !== -1) {
        newChecked = newChecked.filter(item => item !== selected)

        for(let i = 0; i < this.state.triggerData.length; i++) {
          if(newChecked.indexOf(this.state.triggerData[i].Label) !== -1 && this.state.triggerData[i].Label !== "ALL") {
            selectedData.push(this.state.triggerData[i])
          }
        }

        let data = []
        let dataObj = {}
        let dataCustPros = []
        let dataLocation = []
        let dataTrigType = []
        let dataOverall = []
        let dataWeekly = []

        for(let i = 0; i < selectedData.length; i++) {
          if(this.state.selectedType === "market") {
            dataCustPros.push(selectedData[i]["Data_CustPros"])
            dataLocation.push(selectedData[i]["Data_Location"])
            dataTrigType.push(selectedData[i]["Data_TrigType"])
            dataOverall.push(selectedData[i]["Data_Overall"][0])
            dataWeekly.push(selectedData[i]["Data_Weekly"])
          } else {
            dataCustPros.push(selectedData[i]["Data_CustPros"])
            dataTrigType.push(selectedData[i]["Data_TrigType"])
            dataOverall.push(selectedData[i]["Data_Overall"][0])
            dataWeekly.push(selectedData[i]["Data_Weekly"])
          }
        }

        let custProsNames = dataCustPros[0].map(item => item.Label)
        const custProsArr = []

        for(let i = 0; i < custProsNames.length; i++) {
          const custProsObj = {}
          custProsObj['label'] = custProsNames[i]
          custProsObj['Data'] = []
          for(let j = 0; j < dataCustPros.length; j++) {
            custProsObj['Data'].push(dataCustPros[j].filter(item => item.Label === custProsNames[i])[0])
          }
          custProsArr.push(custProsObj)
        }
        const custProsTotal = [custProsArr.map(item => item.Data.reduce((a,b) => {
          for(const prop in b) {
            if(a.hasOwnProperty(prop) && prop !== 'Label') a[prop] += b[prop]
            else a[prop] = b[prop]
          }
          return a
        }, {}))]

        let locationNames = dataLocation.length > 0 ? dataLocation[0].map(item => item.Label) : []
        const locationsArr = []

        if(locationNames.length > 0) {
          for(let i = 0; i < locationNames.length; i++) {
            const locationObj = {}
            locationObj['label'] = locationNames[i]
            locationObj['Data'] = []
            for(let j = 0; j < dataLocation.length; j++) {
              locationObj['Data'].push(dataLocation[j].filter(item => item.Label === locationNames[i])[0])
            }
            locationsArr.push(locationObj)
          }
        }
        const locationTotal = [locationsArr.map(item => item.Data.reduce((a,b) => {
          for(const prop in b) {
            if(a.hasOwnProperty(prop) && prop !== 'Label') a[prop] += b[prop]
            else a[prop] = b[prop]
          }
          return a
        }, {}))]

        let trigTypes = dataTrigType[0].map(item => item.Label)
        const trigArray = []

        for(let i = 0; i < trigTypes.length; i++) {
          const trigObj = {}
          trigObj['Data'] = []
          for(let j = 0; j < dataTrigType.length; j++) {
            trigObj['Data'].push(dataTrigType[j].filter(item => item.Label === trigTypes[i])[0])
          }
          trigArray.push(trigObj)
        }
        const trigTotal = [trigArray.map(item => item.Data.reduce((a,b) => {
          for(const prop in b) {
            if(a.hasOwnProperty(prop) && prop !== 'Label') a[prop] += b[prop]
            else a[prop] = b[prop]
          }
          return a
        }, {}))]

        let weeklyLabels = dataWeekly[0].map(item => item.Label)
        let weeklyArr = []
        for(let i = 0; i < weeklyLabels.length; i++) {
          const weeklyObj = {}
          weeklyObj['Data'] = []
          for(let j = 0; j < dataWeekly.length; j++) {
            weeklyObj['Data'].push(dataWeekly[j].filter(item => item.Label === weeklyLabels[i])[0])
          }
          weeklyArr.push(weeklyObj)
        }
        const weeklyTotal = [weeklyArr.map(item => item.Data.reduce((a,b) => {
          for(const prop in b) {
            if(a.hasOwnProperty(prop) && prop !== 'Label') a[prop] += b[prop]
            else a[prop] = b[prop]
          }
          return a
        }, {}))]

        const dataOverallTotal = [dataOverall.reduce((a,b) => {
          for(const prop in b) {
            if(a.hasOwnProperty(prop)) a[prop] += b[prop]
            else a[prop] = b[prop]
          }
          return a
        }, {})]

        dataObj["Data_Overall"] = dataOverallTotal
        dataObj["Data_CustPros"] = custProsTotal[0]
        dataObj["Data_Location"] = locationTotal[0]
        dataObj["Data_TrigType"] = trigTotal[0]
        dataObj["Data_Weekly"] = weeklyTotal[0]
        data.push(dataObj)

        this.setState({
          checked: newChecked.filter(item => item !== "ALL"),
          selectedTriggerData: data
        })

      } else {
        newChecked.push(selected)

        for(let i = 0; i < this.state.triggerData.length; i++) {
          if(newChecked.indexOf(this.state.triggerData[i].Label) !== -1 && this.state.triggerData[i].Label !== "ALL") {
            selectedData.push(this.state.triggerData[i])
          }
        }

        let data = []
        let dataObj = {}
        let dataCustPros = []
        let dataLocation = []
        let dataTrigType = []
        let dataOverall = []
        let dataWeekly = []

        for(let i = 0; i < selectedData.length; i++) {
          if(this.state.selectedType === "market") {
            dataCustPros.push(selectedData[i]["Data_CustPros"])
            dataLocation.push(selectedData[i]["Data_Location"])
            dataTrigType.push(selectedData[i]["Data_TrigType"])
            dataOverall.push(selectedData[i]["Data_Overall"][0])
            dataWeekly.push(selectedData[i]["Data_Weekly"])
          } else {
            dataCustPros.push(selectedData[i]["Data_CustPros"])
            dataTrigType.push(selectedData[i]["Data_TrigType"])
            dataOverall.push(selectedData[i]["Data_Overall"][0])
            dataWeekly.push(selectedData[i]["Data_Weekly"])
          }
        }

        let custProsNames = dataCustPros[0].map(item => item.Label)
        const custProsArr = []

        for(let i = 0; i < custProsNames.length; i++) {
          const custProsObj = {}
          custProsObj['label'] = custProsNames[i]
          custProsObj['Data'] = []
          for(let j = 0; j < dataCustPros.length; j++) {
            custProsObj['Data'].push(dataCustPros[j].filter(item => item.Label === custProsNames[i])[0])
          }
          custProsArr.push(custProsObj)
        }
        const custProsTotal = [custProsArr.map(item => item.Data.reduce((a,b) => {
          for(const prop in b) {
            if(a.hasOwnProperty(prop) && prop !== 'Label') a[prop] += b[prop]
            else a[prop] = b[prop]
          }
          return a
        }, {}))]

        let locationNames = dataLocation.length > 0 ? dataLocation[0].map(item => item.Label) : []
        const locationsArr = []

        if(locationNames.length > 0) {
          for(let i = 0; i < locationNames.length; i++) {
            const locationObj = {}
            locationObj['label'] = locationNames[i]
            locationObj['Data'] = []
            for(let j = 0; j < dataLocation.length; j++) {
              locationObj['Data'].push(dataLocation[j].filter(item => item.Label === locationNames[i])[0])
            }
            locationsArr.push(locationObj)
          }
        }
        const locationTotal = [locationsArr.map(item => item.Data.reduce((a,b) => {
          for(const prop in b) {
            if(a.hasOwnProperty(prop) && prop !== 'Label') a[prop] += b[prop]
            else a[prop] = b[prop]
          }
          return a
        }, {}))]

        let trigTypes = dataTrigType[0].map(item => item.Label)
        const trigArray = []

        for(let i = 0; i < trigTypes.length; i++) {
          const trigObj = {}
          trigObj['Data'] = []
          for(let j = 0; j < dataTrigType.length; j++) {
            trigObj['Data'].push(dataTrigType[j].filter(item => item.Label === trigTypes[i])[0])
          }
          trigArray.push(trigObj)
        }
        const trigTotal = [trigArray.map(item => item.Data.reduce((a,b) => {
          for(const prop in b) {
            if(a.hasOwnProperty(prop) && prop !== 'Label') a[prop] += b[prop]
            else a[prop] = b[prop]
          }
          return a
        }, {}))]

        let weeklyLabels = dataWeekly[0].map(item => item.Label)
        let weeklyArr = []
        for(let i = 0; i < weeklyLabels.length; i++) {
          const weeklyObj = {}
          weeklyObj['Data'] = []
          for(let j = 0; j < dataWeekly.length; j++) {
            weeklyObj['Data'].push(dataWeekly[j].filter(item => item.Label === weeklyLabels[i])[0])
          }
          weeklyArr.push(weeklyObj)
        }
        const weeklyTotal = [weeklyArr.map(item => item.Data.reduce((a,b) => {
          for(const prop in b) {
            if(a.hasOwnProperty(prop) && prop !== 'Label') a[prop] += b[prop]
            else a[prop] = b[prop]
          }
          return a
        }, {}))]

        const dataOverallTotal = [dataOverall.reduce((a,b) => {
          for(const prop in b) {
            if(a.hasOwnProperty(prop)) a[prop] += b[prop]
            else a[prop] = b[prop]
          }
          return a
        }, {})]

        dataObj["Data_Overall"] = dataOverallTotal
        dataObj["Data_CustPros"] = custProsTotal[0]
        dataObj["Data_Location"] = locationTotal[0]
        dataObj["Data_TrigType"] = trigTotal[0]
        dataObj["Data_Weekly"] = weeklyTotal[0]
        data.push(dataObj)

        this.setState({
          checked: newChecked,
          selectedTriggerData: data
        })
      }

    } else {
      if(this.state.checked.length === this.state.checkList.length) {
        this.setState({
          checked: [],
          selectedTriggerData: [],
        })
      } else {
        this.setState({
          checked: this.state.checkList,
          selectedTriggerData: this.state.triggerData.filter(item => item.Label === "ALL")
        })
      }
    }

    // if(values.length === this.state.triggerData.filter(item => item.Label !== 'ALL').length) {
    //   this.setState({
    //     selectedMarkets: ['ALL'],
    //     checked: this.state.triggerData.map(item => item.Label),
    //     selectedTriggerData: this.state.triggerData.filter(item => item.Label === 'ALL')
    //   })
    // } else if(values.length > 1 && this.state.selectedMarkets.includes('ALL')
    //   || values.length >= 1 && values.includes('ALL') === false
    // ) {
    //   if(values.filter(item => item !== 'ALL').length < 2) {
    //     let filter = values.filter(item => item !== 'ALL')[0]
    //
    //     this.setState({
    //       selectedTriggerData: this.state.triggerData.filter(item => item.Label === filter)
    //     })
    //   } else {
    //     selectedTrigMarkets.push(this.state.triggerData.filter(item => values.includes(item.Label) && item.Label !== 'ALL'))
    //
    //     let data = []
    //     let dataObj = {}
    //     let dataCustPros = []
    //     let dataLocation = []
    //     let dataTrigType = []
    //     let dataOverall = []
    //     let dataWeekly = []
    //
    //     for(let i = 0; i < selectedTrigMarkets[0].length; i++) {
    //       if(this.state.selectedType === 'market') {
    //         dataCustPros.push(selectedTrigMarkets[0][i]['Data_CustPros'])
    //         dataLocation.push(selectedTrigMarkets[0][i]['Data_Location'])
    //         dataTrigType.push(selectedTrigMarkets[0][i]['Data_TrigType'])
    //         dataOverall.push(selectedTrigMarkets[0][i]['Data_Overall'][0])
    //         dataWeekly.push(selectedTrigMarkets[0][i]['Data_Weekly'])
    //       } else {
    //         dataCustPros.push(selectedTrigMarkets[0][i]['Data_CustPros'])
    //         dataTrigType.push(selectedTrigMarkets[0][i]['Data_TrigType'])
    //         dataOverall.push(selectedTrigMarkets[0][i]['Data_Overall'][0])
    //         dataWeekly.push(selectedTrigMarkets[0][i]['Data_Weekly'])
    //
    //       }
    //     }
    //
    //     // CUSTPROS DATA FOR MULTIPLE MARKET SELECTS
    //     let custProsNames = dataCustPros[0].map(item => item.Label)
    //     const custProsArr = []
    //
    //     for(let i = 0; i < custProsNames.length; i++) {
    //       const custProsObj = {}
    //       custProsObj['label'] = custProsNames[i]
    //       custProsObj['Data'] = []
    //       for(let j = 0; j < dataCustPros.length; j++) {
    //         custProsObj['Data'].push(dataCustPros[j].filter(item => item.Label === custProsNames[i])[0])
    //       }
    //       custProsArr.push(custProsObj)
    //     }
    //     const custProsTotal = [custProsArr.map(item => item.Data.reduce((a,b) => {
    //       for(const prop in b) {
    //         if(a.hasOwnProperty(prop) && prop !== 'Label') a[prop] += b[prop]
    //         else a[prop] = b[prop]
    //       }
    //       return a
    //     }, {}))]
    //
    //     // LOCATION DATA FOR MULTIPLE MARKET SELECTS
    //     let locationNames = dataLocation.length > 0 ? dataLocation[0].map(item => item.Label) : []
    //     const locationsArr = []
    //
    //     for(let i = 0; i < locationNames.length; i++) {
    //       const locationObj = {}
    //       locationObj['label'] = locationNames[i]
    //       locationObj['Data'] = []
    //       for(let j = 0; j < dataLocation.length; j++) {
    //         locationObj['Data'].push(dataLocation[j].filter(item => item.Label === locationNames[i])[0])
    //       }
    //       locationsArr.push(locationObj)
    //     }
    //     const locationTotal = [locationsArr.map(item => item.Data.reduce((a,b) => {
    //       for(const prop in b) {
    //         if(a.hasOwnProperty(prop) && prop !== 'Label') a[prop] += b[prop]
    //         else a[prop] = b[prop]
    //       }
    //       return a
    //     }, {}))]
    //
    //     // TRIGTYPE DATA FOR MULTIPLE MARKET SELECTS
    //     let trigTypeNames = dataTrigType[0].map(item => item.Label)
    //     const trigTypeArr = []
    //
    //     for(let i = 0; i < trigTypeNames.length; i++) {
    //       const trigTypeObj = {}
    //       trigTypeObj['Data'] = []
    //       for(let j = 0; j < dataTrigType.length; j++) {
    //         trigTypeObj['Data'].push(dataTrigType[j].filter(item => item.Label === trigTypeNames[i])[0])
    //       }
    //       trigTypeArr.push(trigTypeObj)
    //     }
    //     const trigTypeTotal = [trigTypeArr.map(item => item.Data.reduce((a,b) => {
    //       for(const prop in b) {
    //         if(a.hasOwnProperty(prop) && prop !== 'Label') a[prop] += b[prop]
    //         else a[prop] = b[prop]
    //       }
    //       return a
    //     }, {}))]
    //
    //     // WEEKLY DATA FOR MULTIPLE MARKET SELECTS
    //     let weeklyLabels = dataWeekly[0].map(item => item.Label)
    //     let weeklyArr = []
    //     for(let i = 0; i < weeklyLabels.length; i ++) {
    //       const weeklyObj = {}
    //       weeklyObj['Data'] = []
    //       for(let j = 0; j < dataWeekly.length; j++) {
    //         weeklyObj['Data'].push(dataWeekly[j].filter(item => item.Label === weeklyLabels[i])[0])
    //       }
    //       weeklyArr.push(weeklyObj)
    //     }
    //     const weeklyTotal = [weeklyArr.map(item => item.Data.reduce((a,b) => {
    //       for(const prop in b) {
    //         if(a.hasOwnProperty(prop) && prop !== 'Label') a[prop] += b[prop]
    //         else a[prop] = b[prop]
    //       }
    //       return a
    //     }, {}))]
    //
    //     // OVERALL DATA FOR MULTIPLE MARKET SELECTS
    //     const dataOverallTotal = [dataOverall.reduce((a,b) => {
    //       for(const prop in b) {
    //         if(a.hasOwnProperty(prop)) a[prop] += b[prop]
    //         else a[prop] = b[prop]
    //       }
    //       return a
    //     }, {})]
    //
    //     dataObj['Data_Overall'] = dataOverallTotal
    //     dataObj['Data_Location'] = locationTotal[0].length > 0 ? locationTotal[0] : null
    //     dataObj['Data_CustPros'] = custProsTotal[0]
    //     dataObj['Data_TrigType'] = trigTypeTotal[0]
    //     dataObj['Data_Weekly'] = weeklyTotal[0]
    //     data.push(dataObj)
    //
    //     this.setState({
    //       selectedTriggerData: data
    //     })
    //   }
    //   this.setState({
    //     selectedMarkets: values.filter(item => item !== 'ALL'),
    //     checked: values.filter(item => item !== 'ALL'),
    //   })
    // } else {
    //   console.log('this one')
    //   this.setState({
    //     selectedMarkets: ['ALL'],
    //     checked: this.state.triggerData.map(item => item.Label),
    //     selectedTriggerData: this.state.triggerData.filter(item => item.Label === 'ALL')
    //   })
    // }
  }

  handleMailingTypeOpen = (e) => {

    this.setState({
      mailingOpen: true,
      anchor: e.currentTarget,
    })
  }

  changeMailingType = (e) => {
    const {myValue} = e.currentTarget.dataset
    let myHeaders = {'token': Cookies.get('token')}
    let complete = myValue === 'completed' ? 1 : 0

    Promise.all([
      fetch(`${base_url}/triggerROI?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
      fetch(`${base_url}/triggerROI/custPros?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
      fetch(`${base_url}/triggerRoi/trigType?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders}),
      fetch(`${base_url}/triggerROI/weekly?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders,}),
      fetch(`${base_url}/triggerROI/dashboard/${this.state.selectedType}?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders,}),
      fetch(`${base_url}/triggerROI/dashboard?startDate=${this.state.startDate.format('YYYY-MM-DD')}&endDate=${this.state.endDate.format('YYYY-MM-DD')}&complete=${complete}`, {headers: myHeaders,}),
    ])
    .then(([response1, response2, response3, response4, response5, response6]) => Promise.all([response1.json(), response2.json(), response3.json(), response4.json(), response5.json(), response6.json()]))
    .then(([data1, data2, data3, data4, data5, data6]) => {
      if(this._isMounted && data1) {
        console.log(data1)
        let trigData = []
        let trigObj = {}
        trigObj['Data_CustPros'] = data2
        trigObj['Data_Location'] = data6[0].Data_Location
        trigObj['Data_TrigType'] = data3
        trigObj['Data_Weekly'] = data4
        trigObj['Data_Overall'] = data1[0].Data

        trigObj['Label'] = 'ALL'
        trigObj['Key'] = data5.length + 1
        trigData.push(trigObj)

        this.setState({
          isLoading: false,
          hasData: true,
          triggerData: trigData.concat(data5),
          selectedTriggerData: trigData.concat(data5).filter(item => this.state.selectedMarkets.includes(item.Label)),
          triggerMarketData: data5,
        })
      } else {
        this.setState({
              isLoading: false,
              snackbar: true,
              errorMessage: 'Trigger ROI is not available for the selection(s) you have made. Please broaden your search and try again.',
              triggerData: []
            })
      }
    })

    this.setState({
      mailingType: myValue,
    })

    console.log(myValue)

    this.handleMailingTypeClose()
  }

  handleMailingTypeClose = () => {
    this.setState({
      mailingOpen: false,
    })
  }

  handleDeselectMarket = (e, label) => {
    const filteredMarkets = this.state.selectedMarkets.filter(item => item !== label)
    this.handleMarketChange(filteredMarkets)
  }

  renderMarketSelectOptions = () => {
    console.log(this.state.checkList)

    return (
      this.state.checkList.map((item, i) => (
        <MenuItem
          key={i}
          value={item}
          style={this.state.selectedMarkets.indexOf(item) === -1 ? {} : {fontWeight: 'bold'}}
        >
          <div style={{display: 'inline-flex', alignItems: 'center', justifyContent: 'space-between'}}>
            <Checkbox
              edge="start"
              size="small"
              checked={this.state.checked.indexOf(item) !== -1}
              disableRipple
              style={item === 'ALL' ? {display: 'none'} : {}}
            />
            <Typography variant="caption" style={{width: 200}}>
              {item === 'ALL' ? this.state.checked.length === this.state.checkList.length ? `DESELECT ${item} ${this.state.selectedType.toUpperCase()}S` : `SELECT ${item} ${this.state.selectedType.toUpperCase()}S` : item}
            </Typography>
          </div>
        </MenuItem>
      ))
    )
  }

  // renderMarketSelectOptions = () => {
  //   return (
  //     this.state.triggerData.map(item => (
  //       <MenuItem
  //         key={item.Key}
  //         value={item.Label}
  //         style={this.state.selectedMarkets.indexOf(item.Label) === -1 ? {} : {fontWeight: 'bold'}}
  //       >
  //         <div style={{display: 'inline-flex', alignItems: 'center'}}>
  //           <Checkbox
  //             edge="start"
  //             size="small"
  //             checked={this.state.checked.indexOf(item.Label) !== -1}
  //             disableRipple
  //           />
  //           <Typography variant="caption" style={{width: 200}}>
  //             {item.Label === 'ALL' ? `${item.Label} ${this.state.selectedType.toUpperCase()}S` : item.Label.includes('_') ? item.Label.split('_').join(' ').toUpperCase() : item.Label.includes('-') ? item.Label.split('-').join(' ').toUpperCase() : item.Label.toUpperCase()}
  //           </Typography>
  //         </div>
  //       </MenuItem>
  //     ))
  //   )
  // }

  getSelectedData = (data) => {
    console.log(data)

    const metricArr = []

    if(data[0]) {
      for(let i = 0; i < data.length; i++) {
        for(let j = 0; j < data[i].length; j++) {
          if(metricArr.map(item => item.label).indexOf(data[i][j].Label) === -1) {
            metricArr.push({label: data[i][j].Label})
          }
        }
      }
    }

    for(let i = 0; i < metricArr.length; i++) {
      metricArr[i]['data'] = []
      for(let j = 0; j < data.length; j++) {
        for(let k = 0; k < data[j].length; k++) {
          if(metricArr[i].label === data[j][k].Label) {
            metricArr[i]['data'].push(data[j][k])
          }
        }
      }
    }

    metricArr.forEach(element => {
      element['total'] = element.data.reduce((a,b) => {
        for(const prop in b) {
          if(a.hasOwnProperty(prop)) a[prop] += b[prop]
          else a[prop] = b[prop]
        }
        return a
      }, {})
    })

    return metricArr
  }

  render() {
    const { classes } = this.props

    const overallData = this.getSelectedData(this.state.selectedTriggerData ? this.state.selectedTriggerData.map(item => item.Data_Overall) : [])
    const custProsData = this.getSelectedData(this.state.selectedTriggerData ? this.state.selectedTriggerData.map(item => item.Data_CustPros) : [])
    const trigTypeData = this.getSelectedData(this.state.selectedTriggerData ? this.state.selectedTriggerData.map(item => item.Data_TrigType) : [])
    const locationData = this.getSelectedData(this.state.selectedTriggerData ? this.state.selectedTriggerData.map(item => item.Data_Location) : [])
    const weeklyData = this.getSelectedData(this.state.selectedTriggerData ? this.state.selectedTriggerData.map(item => item.Data_Weekly) : [])
    const screenWidth = window.innerWidth

    return(
      <div className={classes.root}>
        {this.state.isLoading ? <div className={classes.loader}><CircularProgress /></div> :
        this.state.hasData ?
        <Fragment>
          <Snackbar
            open={this.state.snackbar}
            autoHideDuration={4500}
            onClose={this.handleSnackbarClose}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
          >
            <SnackbarContent
              message={
                <div style={{display: 'flex'}}>
                  <WarningIcon className={classes.error} fontSize="small" fontWeight="bold"/>
                  <span style={{fontWeight: 600, marginLeft: '15px'}}>{this.state.errorMessage}</span>
                </div>
              }
              style={this.props.darkMode ?
                {color: '#fff', backgroundColor: '#ff9800'}
              :
                {backgroundColor: '#ff9800'}
              }
            />
          </Snackbar>
          {/* PAGE HEADER */}
          {this.state.marketLoading ?
            <div>
              <CircularProgress className={classes.loader} style={{position: 'absolute', zIndex: 10000}}/>
            </div>
          :
            <div />
          }

          <div style={this.state.marketLoading ? {opacity: 0.5} : {}}>
            <Fade in={true}>
              <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div>
                  <Typography className={classes.pageTitleDark} style={{marginTop: '5px'}}>
                    <TelegramIcon className={classes.pageIconDark} />
                    <span style={{marginLeft: '5px', fontWeight: 'bold'}}>TRIGGERS</span>
                  </Typography>
                </div>
              <div className={classes.filter}>
                <Typography variant="caption" style={{color: "#fff"}}>
                  Showing <span onClick={this.handleMailingTypeOpen} className={this.props.darkMode ? classes.mailingTypeDark : classes.mailingType}>{`${this.state.mailingType.toUpperCase()} MAILINGS`}</span> from:
                </Typography>
                  <Menu
                    anchorEl={this.state.anchor}
                    open={this.state.mailingOpen}
                    onClose={this.handleMailingTypeClose}
                  >
                    <MenuItem onClick={e => this.changeMailingType(e)} data-my-value={'completed'}><Typography variant="caption">COMPLETE MAILINGS</Typography></MenuItem>
                    <MenuItem onClick={e => this.changeMailingType(e)} data-my-value={'all'}><Typography variant="caption">ALL MAILINGS</Typography></MenuItem>
                  </Menu>
                    <div style={{display: 'flex', marginTop: '2px', alignItems: 'center'}}>
                      {this.state.marketLoading ? <div/> :
                        <div style={{marginRight: '15px'}}>
                          <RoiExcel
                            pageName={'TRIGGER'}
                            markets={this.state.selectedMarkets}
                            selectedType={this.state.selectedType}
                            startDate={this.state.startDate.format('MMM DD YYYY')}
                            endDate={this.state.endDate.format('MMM DD YYYY')}
                            selectedData={this.state.selectedTriggerData[0]}
                          />
                        </div>
                      }
                      <Select
                        variant="outlined"
                        value={this.state.selectedType}
                        onChange={e => this.handleSelectedType(e.target.value)}
                        input={<StyledInput style={{width: '150px'}}/>}
                        style={{marginRight: '15px', textAlign: 'left'}}
                      >
                        <MenuItem value={'market'}>
                          <div style={{padding: '5px 15px 0px 15px'}}>
                            <Typography variant="caption">
                              BY MARKET
                            </Typography>
                          </div>
                        </MenuItem>
                        <MenuItem value={'location'}>
                          <div style={{padding: '5px 15px 0px 15px'}}>
                            <Typography variant="caption">
                              BY LOCATION
                            </Typography>
                          </div>
                        </MenuItem>
                      </Select>
                      <div style={{marginRight: '15px', textAlign: 'left'}}>
                        <Select
                          multiple
                          value={this.state.selectedMarkets}
                          onChange={e => this.handleMarketChange(e.target.value)}
                          input={<StyledInput style={{minWidth: 200, maxWidth: 350}}/>}
                          // renderValue={selected => (
                          //   selected.length > 1 ?
                          //   <div style={{padding: '5px 0px 0px 20px'}}>
                          //     <Typography variant="caption">{`${selected.length} ${this.state.selectedType.toUpperCase()}S SELECTED`}</Typography>
                          //   </div>
                          //   :
                          //   <div style={{padding: '5px 0px 0px 20px'}}>
                          //     {selected.map(value => (
                          //       <Typography key={value} variant="caption">{value === 'ALL' ? value + ' ' + this.state.selectedType.toUpperCase() + 'S' : value}</Typography>
                          //     ))}
                          //   </div>
                          // )}
                          renderValue={() => (
                            this.state.checked.length !== this.state.checkList.length ?
                              <div style={{padding: '5px 0px 0px 20px'}}>
                                <Typography variant="caption">{`${this.state.checked.length} ${this.state.selectedType.toUpperCase()}S`} SELECTED</Typography>
                              </div>
                            :
                              <div style={{padding: '5px 0px 0px 20px'}}>
                                <Typography variant="caption">{`ALL ${this.state.selectedType.toUpperCase()}S`}</Typography>
                              </div>
                          )}
                        >
                          {this.renderMarketSelectOptions()}
                        </Select>
                      </div>

                    <div className={classes.datePicker}>
                      <DayPicker
                        startDate={this.state.minYearmo}
                        endDate={this.state.maxYearmo}
                        maxSliderValue={this.state.days}
                        handleDateRange={this.handleDateRange}
                        handleSliderDateChange={this.handleSliderDateChange}
                        handleDateClear={this.handleDateClear}
                        restoreHidden={this.state.restoreHidden}
                        allowBeforeJan={false}
                        maxDate={'trig'}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
            <div
              style={
                this.state.selectedTriggerData.length > 0 ?
                this.state.selectedTriggerData.map(item => item.Data_Overall[0]).reduce((a,b) => {
                  for(const prop in b) {
                    if(a.hasOwnProperty(prop)) a[prop] += b[prop]
                    else a[prop] = b[prop]
                  }
                  return a
                }, {}).HO_Count > 7500 ?
                {display: 'none'} : { marginTop: '15px'} : {}
              }
            >
              <Fade in={true} timeout={2000}>
                <div className={classes.warning}>
                  <div style={{margin: '1em', display: 'inline-flex', alignItems: 'center'}}>
                    <WarningIcon style={{color: '#de9f10'}}/>
                    <Typography align="center" variant="caption" style={{marginLeft: '5px', color: "#fff"}}>
                      Due to the low holdout quantity, the holdout responses may not be statistically significant.
                    </Typography>
                  </div>
                </div>
              </Fade>
            </div>
            <br />
            <Stats
              data={
                this.state.selectedTriggerData.length > 0 ?
                this.state.selectedTriggerData.map(item => item.Data_Overall[0]).reduce((a,b) => {
                  for(const prop in b) {
                    if(a.hasOwnProperty(prop)) a[prop] += b[prop]
                    else a[prop] = b[prop]
                  }
                  return a
                }, {}) : []
              }
              darkMode={this.props.darkMode}
            />
            <br />
            <Fade in={true} timeout={500}>
              <Typography align="center" className="roi-statement">
                On completed promotions, a total spend of <span style={{color: "#fc5b5b"}}>
                  ${this.state.selectedTriggerData.length > 0 ?
                    this.state.selectedTriggerData.map(item => item.Data_Overall[0]).reduce((a,b) => {
                      for(const prop in b) {
                        if(a.hasOwnProperty(prop)) a[prop] += b[prop]
                        else a[prop] = b[prop]
                      }
                      return a
                    }, {}).Cost.toLocaleString('en', {maximumFractionDigits: 0})
                    : 0
                  }
                </span> has yielded <span style={{color: "#92e635", fontWeight:'bold'}}>
                  ${this.state.selectedTriggerData.length > 0 ?
                    this.state.selectedTriggerData.map(item => item.Data_Overall[0]).reduce((a,b) => {
                      for(const prop in b) {
                        if(a.hasOwnProperty(prop)) a[prop] += b[prop]
                        else a[prop] = b[prop]
                      }
                      return a
                    }, {}).Sales.toLocaleString('en', {maximumFractionDigits: 0})
                    : 0
                  }
                </span> in sales to responders (at a {this.state.selectedTriggerData.length > 0 ?
                  (this.state.selectedTriggerData.map(item => item.Data_Overall[0]).reduce((a,b) => {
                    for(const prop in b) {
                      if(a.hasOwnProperty(prop)) a[prop] += b[prop]
                      else a[prop] = b[prop]
                    }
                    return a
                  }, {}).Responses / this.state.selectedTriggerData.map(item => item.Data_Overall[0]).reduce((a,b) => {
                    for(const prop in b) {
                      if(a.hasOwnProperty(prop)) a[prop] += b[prop]
                      else a[prop] = b[prop]
                    }
                    return a
                  }, {}).Mailed * 100).toFixed(1)
                  : 0
                }% response rate).<br/> Of the sales to responders, <span style={{color: "#f0e043", fontWeight:'bold'}}>
                  ${this.state.selectedTriggerData.length > 0 ?
                    overallData[0].total.HO_Count > 0 ?
                    (overallData[0].total.Responses / overallData[0].total.Mailed) - (overallData[0].total.HO_Resp / overallData[0].total.HO_Count) > 0 ?
                    Math.round((overallData[0].total.Sales / (overallData[0].total.Responses / overallData[0].total.Mailed)) * ((overallData[0].total.Responses / overallData[0].total.Mailed) - (overallData[0].total.HO_Resp / overallData[0].total.HO_Count))).toLocaleString('en')
                    : 0 : Math.round(overallData[0].total.Sales / (overallData[0].total.Responses / overallData[0].total.Mailed)).toLocaleString("en") : 0
                  }
                </span> are purely incremental.
              </Typography>
            </Fade>
            <br />
            <Fade in={true}>
              <RoiTable
                title={"Customers vs Prospects"}
                data={this.state.selectedTriggerData.length > 0 ? custProsData : []}
                colors={['#a3dbff', '#ffed75']}
              />
            </Fade>
            <br />
            <br />
            <Fade in={true}>
              <RoiTable
                data={this.state.selectedTriggerData.length > 0 ? trigTypeData : []}
                colors={['#00d2da', '#f2b000', '#85fa3e', '#ff7dae', '#ffa159', '#add449', '#92baf0', '#cfa895', '#ffbdf0']}
                darkMode={this.props.darkMode}
                title={"Product Categories"}
                roi={"triggers"}
              />
            </Fade>
              {/* <TriggerTypesTable data={this.state.selectedTriggerData.length > 0 ? trigTypeData : []} darkMode={this.props.darkMode}/> */}
            <br />
            <br />
            <Fade in={true}>
              <div style={this.state.selectedType === 1 ? {display: 'none'} : {}}>
                <RoiTable
                  data={this.state.selectedTriggerData.length > 0 ? locationData : []}
                  markets={this.state.selectedMarkets}
                  darkMode={this.props.darkMode}
                  title={"Locations"}
                />
              </div>
            </Fade>
                {/* <TrigLocationsTable data={this.state.selectedTriggerData.length > 0 ? locationData : []} markets={this.state.selectedMarkets} darkMode={this.props.darkMode}/> */}
          </div>
        </Fragment>
        : <div className={classes.root} style={{position: 'relative', textAlign: 'center', marginTop: '25px'}}>
          <div className={classes.unavailable}>
            <Typography style={{fontSize: '50px', color: '#0c5ab4', fontWeight: 'bold'}}>COMING SOON</Typography>
            <Typography variant="caption" style={{fontSize: '25px'}}>This screen is unavailable at this time. For more information please contact Support at <a href="mailto: support@lsdirect.com">support@lsdirect.com</a></Typography>
          </div>
          <img style={{width: '98%'}} src={roiMainStandIn} alt="" />
        </div>
        }
      </div>
    )
  }
}

export default withStyles(styles)(Triggers)
